export function isOfferCardEmpty(props) {
    return !props[':type'];
}
